/* eslint-disable vue/require-v-for-key */
<template>
  <div class="col">
    <form
      @submit="sendForm"
      class="mt-3"
      v-if="canAdd || isEdit"
      id="addTemplateForm"
    >
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12 mb-2">
              <h4><span v-if="formType == 'create'">Add</span><span v-else>Edit</span> Template</h4>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 form-group">
              <label class="label label-default required">Name</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="formData.Name"
                :readonly="formType === 'edit'"
              >
              <small class="text-muted">Min. 5 characters, Only letters, numbers, dots, hyphens & underscores</small>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 form-group">
              <label class="label label-default required">Type</label>
              <select
                name="CampaignsTemplate"
                v-model="formData.Type"
                placeholder="Please Select"
                class="custom-select form-control"
                @change="checkRent($event)"
              >
                <option
                  class="placeholder"
                  disabled
                  value=""
                  selected=""
                >
                  Please Select
                </option>
                <option
                  value="newsletter"
                  hidden
                >
                  News Letter
                </option>
                <option value="featured">
                  Featured Properties
                </option>
                <option value="featured-province">
                  Province Featured Property
                </option>
                <option value="homeespana">
                  Home España
                </option>
                <option value="idiliqestates">
                  Idiliq Estates
                </option>
                <option value="panoramaproperties">
                  Panorama Properties
                </option>
                <option value="taylorwimpey">
                  Taylor Wimpey España
                </option>
                <option value="promocioneseden">
                  Promociones Eden
                </option>
                <option value="bluemed">
                  Bluemed
                </option>
                <option value="aedashomes">
                  Aedas Homes SA
                </option>
                <option value="lavrealestate">
                  Lav Real Estate
                </option>
                <option value="inmoarisrealestate">
                  Inmoaris Real Estate
                </option>
                <option value="vivla">
                  Vivla
                </option>
                <option value="discountpropertycentermarbella">
                  Discount Property Center Marbella
                </option>
                <option value="destinationmarbella">
                  Destination Marbella
                </option>
                <option value="selected150">
                  Affordable Properties
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <!-- FOR SALE -->
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6"
              v-if="!isNewsletter && !isAffordablePropertiesTemplate"
            >
              <div class="row">
                <div class="col-12">
                  <label class="label label-default d-block">Properties For Sale:</label>
                </div>
              </div>

              <draggable
                :list="repeat.sale"
                draggable=".repeat-block"
                @start="dragging=true"
                @end="dragging=false"
              >
                <div
                  class="row repeat-block mb-2 cursor-move"
                  v-for="(item, index) in repeat.sale"
                  :key="index"
                >
                  <div class="col-xl-4 col-lg-4 col-md-3 col-sm-3 col-12">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <button
                          class="btn"
                          type="button"
                        >
                          <i class="jam jam-arrows-v" />
                        </button>
                      </div>
                      <input
                        v-model="item.propertyId"
                        class=" form-control "
                        name="propertyId"
                        placeholder="Property ID"
                        type="number"
                        min="0"
                        @change="checkActiveSelect(item)"
                        @keydown="onlyNumber"
                      >
                    </div>
                    <small
                      v-if="item.isPublic === false"
                      class="text-danger"
                    >This property is OFFLINE</small>
                  </div>
                  <div class="col-xl-5 col-lg col-md-7 col-sm-8 col-12">
                    <div class="input-group">
                      <select
                        class="custom-select"
                        :disabled="item.gallery === null"
                        @change="setPhotoObj(repeat.sale[index], $event)"
                        v-model="repeat.sale[index].selectedImg"
                      >
                        <option
                          value="0"
                          disabled
                          selected
                        >
                          Please select one
                        </option>
                        <option
                          v-for="(elem, index) in item.gallery"
                          :key="index"
                          :data-order="elem.id"
                          :data-url="elem.url"
                          :value="elem.id"
                        >
                          Photo Nº {{ elem.id }}
                        </option>
                      </select>
                      <div class="input-group-append">
                        <button
                          class="btn btn-primary"
                          type="button"
                          :disabled="item.gallery === null"
                          @click="openModalImg(item)"
                        >
                          <i class="jam jam-eye-f" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-12 text-center"
                    title="Set this image as Open Graph COVER"
                    v-if="item.gallery != null"
                  >
                    <div class="custom-control custom-switch">
                      <input
                        type="radio"
                        :id="'switch'+item.propertyId"
                        class="custom-control-input"
                        name="coverImg"
                        :value="coverItemUrl(item)"
                        :checked="checkIfIsCover(item)"
                        :disabled="item.gallery === null"
                        @change="toggleCover(item, $event)"
                      >
                      <label
                        class="custom-control-label"
                        :for="'switch'+item.propertyId"
                      />
                    </div>
                  </div>
                  <div class="col-xl col-lg-1 col-md-1 col-sm-1 col-12">
                    <button
                      type="button"
                      class="btn btn-sm btn-danger text-light remove-btn d-iniline"
                      @click="removeRepeatBlock(index, 'sale')"
                    >
                      <i class="jam jam-minus-circle" />
                    </button>
                    <button
                      v-if="isLastItemList(repeat.sale, index)"
                      type="button"
                      class="btn btn-sm btn-success text-light repeat-btn d-iniline"
                      @click="repeatBlock('sale')"
                    >
                      <i class="jam jam-plus-circle " />
                    </button>
                  </div>
                </div>
              </draggable>

              <div class="row">
                <div class="col-12 mt-4">
                  <small class="d-block mb-2">The mailshot will fail to send if the following criteria is not met</small>
                  <div class="row">
                    <div class="col-6 form-group">
                      <label>Minimum number of online properties:</label>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="12"
                        v-model.number="formData.criteria.forSale.minSelected"
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- FOR RENT -->
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6"
              v-if="isFeatured"
            >
              <div class="row">
                <div class="col-12">
                  <label class="label label-default d-block">Properties For Rent:</label>
                </div>
              </div>
              <draggable
                :list="repeat.rent"
                draggable=".repeat-block"
                @start="dragging=true"
                @end="dragging=false"
              >
                <div
                  class="row repeat-block mb-2 cursor-move"
                  v-for="(item, index) in repeat.rent"
                  :key="index"
                >
                  <div class="col-xl-4 col-lg-4 col-md-3 col-sm-3 col-12">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <button
                          class="btn"
                          type="button"
                        >
                          <i class="jam jam-arrows-v" />
                        </button>
                      </div>
                      <input
                        v-model="item.propertyId"
                        class=" form-control "
                        name="propertyId"
                        placeholder="Property ID"
                        type="number"
                        min="0"
                        @change="checkActiveSelect(item)"
                        @keydown="onlyNumber"
                      >
                      <small
                        v-if="item.isPublic === false"
                        class="text-danger"
                      >This property is OFFLINE</small>
                    </div>
                  </div>
                  <div class="col-xl-5 col-lg col-md-7 col-sm-8 col-12">
                    <div class="input-group">
                      <select
                        class="custom-select"
                        :disabled="item.gallery === null"
                        @change="setPhotoObj(repeat.rent[index], $event)"
                        v-model="repeat.rent[index].selectedImg"
                      >
                        <option
                          value="0"
                          disabled
                          selected
                        >
                          Please select one
                        </option>
                        <option
                          v-for="elem in item.gallery"
                          :key="elem.id"
                          :data-order="elem.id"
                          :data-url="elem.url"
                          :value="elem.id"
                        >
                          Photo Nº {{ elem.id }}
                        </option>
                      </select>
                      <div class="input-group-append">
                        <button
                          class="btn btn-primary"
                          type="button"
                          :disabled="item.gallery === null"
                          @click="openModalImg(item)"
                        >
                          <i class="jam jam-eye-f" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-12 text-center"
                    title="Set this image as Open Graph COVER"
                    v-if="item.gallery != null"
                  >
                    <div class="custom-control custom-switch">
                      <input
                        type="radio"
                        :id="'switch'+item.propertyId"
                        class="custom-control-input"
                        name="coverImg"
                        :value="coverItemUrl(item)"
                        :checked="coverItemUrl(item) == cover"
                        :disabled="item.gallery === null"
                        @change="toggleCover(item, $event)"
                      >
                      <label
                        class="custom-control-label"
                        :for="'switch'+item.propertyId"
                      />
                    </div>
                  </div>
                  <div class="col-xl col-lg-1 col-md-1 col-sm-1 col-12">
                    <button
                      type="button"
                      class="btn btn-sm btn-danger text-light remove-btn"
                      @click="removeRepeatBlock(index, 'rent')"
                    >
                      <i class="jam jam-minus-circle" />
                    </button>
                    <button
                      v-if="isLastItemList(repeat.rent, index)"
                      type="button"
                      class="btn btn-sm btn-success text-light repeat-btn"
                      @click="repeatBlock('rent')"
                    >
                      <i class="jam jam-plus-circle " />
                    </button>
                  </div>
                </div>
              </draggable>
              <div class="row">
                <div class="col-12 mt-4">
                  <small class="d-block mb-2">The mailshot will fail to send if the following criteria is not met</small>
                  <div class="row">
                    <div class="col-6 form-group">
                      <label>Minimum number of online properties:</label>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="12"
                        v-model.number="formData.criteria.forRent.minSelected"
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- NEWSLETTER -->
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6"
              v-if="isNewsletter"
            >
              <div class="row">
                <div class="col-12">
                  <label class="label label-default d-block">Properties For Sale:</label>
                </div>
              </div>

              <draggable
                :list="repeat.sale"
                draggable=".repeat-block"
                @start="dragging=true"
                @end="dragging=false"
              >
                <div
                  class="row repeat-block mb-2 cursor-move"
                  v-for="(item, index) in repeat.sale"
                  :key="index"
                >
                  <div class="col-xl-4 col-lg-4 col-md-3 col-sm-3 col-12">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <button
                          class="btn"
                          type="button"
                        >
                          <i class="jam jam-arrows-v" />
                        </button>
                      </div>
                      <input
                        v-model="item.propertyId"
                        class=" form-control "
                        name="propertyId"
                        placeholder="Property ID"
                        type="number"
                        min="0"
                        @change="checkActiveSelect(item)"
                        @keydown="onlyNumber"
                      >
                      <small
                        v-if="item.isPublic === false"
                        class="text-danger"
                      >This property is OFFLINE</small>
                    </div>
                  </div>
                  <div class="col-xl-5 col-lg col-md-7 col-sm-8 col-12">
                    <div class="input-group">
                      <select
                        class="custom-select"
                        :disabled="item.gallery === null"
                        @change="setPhotoObj(repeat.sale[index], $event)"
                        v-model="repeat.sale[index].selectedImg"
                      >
                        <option
                          value="0"
                          disabled
                          selected
                        >
                          Please select one
                        </option>
                        <option
                          v-for="elem in item.gallery"
                          :key="elem.id"
                          :data-order="elem.id"
                          :data-url="elem.url"
                          :value="elem.id"
                        >
                          Photo Nº {{ elem.id }}
                        </option>
                      </select>
                      <div class="input-group-append">
                        <button
                          class="btn btn-primary"
                          type="button"
                          :disabled="item.gallery === null"
                          @click="openModalImg(item)"
                        >
                          <i class="jam jam-eye-f" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-12 text-center"
                    title="Set this image as Open Graph COVER"
                    v-if="item.gallery != null"
                  >
                    <div class="custom-control custom-switch">
                      <input
                        type="radio"
                        :id="'switch'+item.propertyId"
                        class="custom-control-input"
                        name="coverImg"
                        :value="coverItemUrl(item)"
                        :checked="checkIfIsCover(item)"
                        :disabled="item.gallery === null"
                        @change="toggleCover(item, $event)"
                      >
                      <label
                        class="custom-control-label"
                        :for="'switch'+item.propertyId"
                      />
                    </div>
                  </div>
                  <div class="col-xl col-lg-1 col-md-1 col-sm-1 col-12">
                    <!--<button v-if="index == 0" type="button" class="btn btn-success text-light repeat-btn" @click="repeatBlock('sale')"><i class="jam jam-plus-circle "></i></button>-->
                    <button
                      type="button"
                      class="btn btn-sm btn-danger text-light remove-btn d-iniline"
                      @click="removeRepeatBlock(index, 'sale')"
                    >
                      <i class="jam jam-minus-circle" />
                    </button>
                    <button
                      v-if="isLastItemList(repeat.sale, index)"
                      type="button"
                      class="btn btn-sm btn-success text-light repeat-btn d-iniline"
                      @click="repeatBlock('sale')"
                    >
                      <i class="jam jam-plus-circle " />
                    </button>
                  </div>
                </div>
              </draggable>
            </div>

            <!-- NEWSLETTER -->
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6"
              v-if="isAffordablePropertiesTemplate"
            >
              <div class="row">
                <div class="col-12">
                  <label class="label label-default d-block">Properties For Sale Less 150.000€:</label>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <draggable
                    :list="repeat.sale"
                    draggable=".repeat-block"
                    @start="dragging=true"
                    @end="dragging=false"
                  >
                    <div
                      class="row repeat-block mb-2 cursor-move"
                      v-for="(item, index) in repeat.sale"
                      :key="index"
                    >
                      <div class="col-xl-4 col-lg-4 col-md-3 col-sm-3 col-12">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <button
                              class="btn"
                              type="button"
                            >
                              <i class="jam jam-arrows-v" />
                            </button>
                          </div>
                          <input
                            v-model="item.propertyId"
                            class=" form-control "
                            name="propertyId"
                            placeholder="Property ID"
                            type="number"
                            min="0"
                            @change="checkActiveSelect(item)"
                            @keydown="onlyNumber"
                          >
                          <small
                            v-if="item.isPublic === false"
                            class="text-danger"
                          >This property is OFFLINE</small>
                        </div>
                      </div>
                      <div class="col-xl-5 col-lg col-md-7 col-sm-8 col-12">
                        <div class="input-group">
                          <select
                            class="custom-select"
                            :disabled="item.gallery === null"
                            @change="setPhotoObj(repeat.sale[index], $event)"
                            v-model="repeat.sale[index].selectedImg"
                          >
                            <option
                              value="0"
                              disabled
                              selected
                            >
                              Please select one
                            </option>
                            <option
                              v-for="elem in item.gallery"
                              :key="elem.id"
                              :data-order="elem.id"
                              :data-url="elem.url"
                              :value="elem.id"
                            >
                              Photo Nº {{ elem.id }}
                            </option>
                          </select>
                          <div class="input-group-append">
                            <button
                              class="btn btn-primary"
                              type="button"
                              :disabled="item.gallery === null"
                              @click="openModalImg(item)"
                            >
                              <i class="jam jam-eye-f" />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-12 text-center"
                        title="Set this image as Open Graph COVER"
                        v-if="item.gallery != null"
                      >
                        <div class="custom-control custom-switch">
                          <input
                            type="radio"
                            :id="'switch'+item.propertyId"
                            class="custom-control-input"
                            name="coverImg"
                            :value="coverItemUrl(item)"
                            :checked="checkIfIsCover(item)"
                            :disabled="item.gallery === null"
                            @change="toggleCover(item, $event)"
                          >
                          <label
                            class="custom-control-label"
                            :for="'switch'+item.propertyId"
                          />
                        </div>
                      </div>
                      <div class="col-xl col-lg-1 col-md-1 col-sm-1 col-12">
                        <button
                          type="button"
                          class="btn btn-sm btn-danger text-light remove-btn d-iniline"
                          @click="removeRepeatBlock(index, 'sale')"
                        >
                          <i class="jam jam-minus-circle" />
                        </button>
                        <button
                          v-if="isLastItemList(repeat.sale, index)"
                          type="button"
                          class="btn btn-sm btn-success text-light repeat-btn d-iniline"
                          @click="repeatBlock('sale')"
                        >
                          <i class="jam jam-plus-circle " />
                        </button>
                      </div>
                    </div>
                  </draggable>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mt-4">
                  <small class="d-block mb-2">The mailshot will fail to send if the following criteria is not met</small>
                  <div class="row">
                    <div class="col-6 form-group">
                      <label>Minimum number of online properties:</label>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="12"
                        v-model.number="formData.criteria.forSale.minSelected"
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <button
            v-if="formType === 'create'"
            type="submit"
            class="btn btn-success d-lg-inline d-md-inline d-inline-block float-xl-right float-lg-right float-md-right float-sm-right"
          >
            <i class="jam jam-save" /> Create Template
          </button>
          <button
            v-if="formType === 'edit'"
            type="submit"
            class="btn btn-success d-lg-inline d-md-inline d-inline-block float-xl-right float-lg-right float-md-right float-sm-right"
          >
            <i class="jam jam-save" /> Edit Template
          </button>
          <button
            v-if="formType === 'edit'"
            type="button"
            class="btn btn-danger d-lg-inline d-md-inline d-inline-block float-xl-right float-lg-right float-md-right float-sm-right mr-1"
            @click="cancelEdit()"
          >
            <i class="jam jam-close" /> Cancel
          </button>
        </div>
      </div>
    </form>

    <div class="row mt-3">
      <div class="col-lg-12">
        <form
          @submit="searchTemplates"
          v-if="!canAdd && !isEdit"
        >
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 mb-2">
                  <h4>Search Templates</h4>
                </div>
                <div class="col-xl col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="templateName"
                  >
                    Name
                  </label>
                  <input
                    v-model="formSearch.Name"
                    type="text"
                    class="form-control"
                    id="templateName"
                    name="templateName"
                    placeholder="Template name (can use %name%)"
                  >
                </div>
                <div class="col-xl col-lg-6 col-md-6 col-sm-12 form-group">
                  <label class="label label-default">Type</label>

                  <select
                    v-model="formSearch.Type"
                    data-ts-placeholder="Please Select"
                    class="custom-select form-control"
                  >
                    <option
                      class="placeholder"
                      value=""
                      selected=""
                    >
                      Please Select
                    </option>
                    <option value="featured">
                      Featured Properties
                    </option>
                    <option value="featured-province">
                      Province Featured Property
                    </option>
                    <option value="homeespana">
                      Home España
                    </option>
                    <option value="idiliqestates">
                      Idiliq Estates
                    </option>
                    <option value="panoramaproperties">
                      Panorama Properties
                    </option>
                    <option value="taylorwimpey">
                      Taylor Wimpey España
                    </option>
                    <option value="promocioneseden">
                      Promociones Eden
                    </option>
                    <option value="bluemed">
                      Bluemed
                    </option>
                    <option value="aedashomes">
                      Aedas Homes SA
                    </option>
                    <option value="lavrealestate">
                      Lav Real Estate
                    </option>
                    <option value="inmoarisrealestate">
                      Inmoaris Real Estate
                    </option>
                    <option value="vivla">
                      Vivla
                    </option>
                    <option value="discountpropertycentermarbella">
                      Discount Property Center Marbella
                    </option>
                    <option value="destinationmarbella">
                      Destination Marbella
                    </option>
                    <option value="selected150">
                      Affordable Properties
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button
                type="submit"
                class="btn btn-primary float-right"
              >
                <i class="jam jam-search" /> Search
              </button>
            </div>
          </div>
        </form>

        <div
          class="row mt-3"
          v-if="!isEdit"
        >
          <div class="col-12">
            <div class="table mt-4">
              <table
                id="campaignsTemplates"
                class="w-100 pb-4 pt-4 responsive white-space table-striped"
              >
                <thead>
                  <tr>
                    <th>
                      Name
                    </th>
                    <th>
                      Type
                    </th>
                    <th>
                      Created On
                    </th>
                    <th class="text-right">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(template, index) in listTemplatesCreated"
                    :key="index"
                  >
                    <td>{{ template.Name }}</td>
                    <td>{{ template.Type }}</td>
                    <td>{{ $moment(template.CreatedOn).format('DD/MM/YYYY HH:mm') }}</td>
                    <td class="text-right">
                      <button
                        class="btn btn-primary btn-sm"
                        @click="openTest(template.Name, '/emailtemplates/'+template.Name+'/sendPreview')"
                      >
                        Send Test
                      </button>
                      <button
                        class="btn btn-primary btn-sm"
                        @click="editTemplate(template.Name)"
                      >
                        Edit
                      </button>
                      <button
                        class="btn btn-danger btn-sm"
                        @click="deleteTemplate(template.Name)"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tfoot />
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="d-none"
      data-extra-fields-send
    >
      <div class="row">
        <div
          class="col-12 mb-2"
          data-field-email
        />
        <div class="col-6">
          <select
            class="custom-select form-control"
            data-ts-lang
          >
            <option value="no">
              Norwegian
            </option>
            <option value="en">
              English
            </option>
            <option value="es">
              Spanish
            </option>
            <option value="de">
              Deutsch
            </option>
            <option value="it">
              Italian
            </option>
            <option value="fr">
              French
            </option>
            <option value="pl">
              Polish
            </option>
            <option value="nl">
              Dutch
            </option>
            <option value="sv">
              Swedish
            </option>
            <option value="da">
              Danish
            </option>
            <option value="fi">
              Finnish
            </option>
            <option value="pt">
              Portuguese
            </option>
            <option value="ry">
              Russian
            </option>
          </select>
        </div>
        <div class="col-6">
          <select
            class="custom-select form-control"
            data-ts-curr
          >
            <option value="EUR">
              Euro
            </option>
            <option value="USD">
              US Dollar
            </option>
            <option value="GBP">
              British Pounds
            </option>
          </select>
        </div>
        <div
          class="col-12"
          data-field-button
        />
      </div>
    </div>
    <img-preview-modal
      v-model="imgPreviewModal.open"
      :src="imgPreviewModal.img"
    />
    <email-test-modal
      v-model="emailTestModal.open"
      @send="sendEmailTest"
    />
  </div>
</template>
<script>
import http from '../../../../http';
import draggable from 'vuedraggable';
import notify from '../../../../notifications';

import ImgPreviewModal from '../ImgPreviewModal.vue';
import EmailTestModal from '../EmailTestModal.vue';

export default {
    data() {
        return {
            imgPreviewModal: {
                open: false,
                img: ''
            },
            emailTestModal: {
                open: false,
                url: null
            },
            editOK: false,
            listTemplatesCreated: [],
            formSearch: {
                Name: null,
                Type: '',
                Take: 20,
                Skip: 0
            },
            formData: {
                Name: null,
                Type: '',
                Data: {
                    CoverURL: null,
                    ForSale: [],
                    ForRent: []
                },
                criteria: {
                    forSale: {
                        minSelected: 12
                    },
                    forRent: {
                        minSelected: 2
                    }
                }
            },
            defaultCriteria: {
                forSale: {
                    minSelected: 12
                },
                forRent: {
                    minSelected: 2
                }
            },
            formType: 'create',
            dragging: false,
            template: '',
            cover: null,
            repeat: {
                featured: [
                    {
                        propertyId: null
                    }
                ],
                sale: [
                    {
                        isCoverItem: false,
                        propertyId: null,
                        gallery: null,
                        selectedImg: 0,
                        photo: {
                            id: null,
                            url: null
                        }
                    }
                ],
                rent: [
                    {
                        isCoverItem: false,
                        propertyId: null,
                        gallery: null,
                        selectedImg: 0,
                        photo: {
                            id: null,
                            url: null
                        }
                    }
                ],
                news: [
                    {
                        isCoverItem: false,
                        newsId: null,
                        gallery: null,
                        selectedImg: 0,
                        photo: {
                            id: null,
                            url: null
                        }
                    }
                ],
                jobs: [
                    {
                        jobId: null
                    }
                ],
                regions: [
                    {
                        jobId: null
                    }
                ]
            },
            templateEdit: null
        };
    },
    computed: {
        isFeatured() {
            return this.formData.Type === 'featured' || this.formData.Type === 'featured-province';
        },
        isAffordablePropertiesTemplate() {
            return this.formData.Type === 'selected150';
        },
        isNewsletter() {
            return this.formData.Type === 'newsletter';
        },
        isEdit() {
            return this.$parent.editing;
        },
        canAdd() {
            return this.$parent.adding;
        },
        canSendTest() {
            return this.cover != null && this.template != null && this.template != '' && ( this.repeat.sale.length > 0 || this.repeat.rent.length > 0 );
        }
    },
    methods: {
        checkIfIsCover( item ) {
            return this.coverItemUrl( item ) === this.cover;
        },
        checkRent( event ) {
            let target = event.target;

            if ( ( target.value === 'featured' || target.value === 'featured-province' ) && this.repeat.rent.length === 0 ) {
                this.repeat.rent.push( {
                    isCoverItem: false,
                    propertyId: null,
                    gallery: null,
                    selectedImg: 0,
                    photo: {
                        id: null,
                        url: null
                    }
                } );
            }
        },
        isLastItemList( list, index ) {
            return list.length === index + 1;
        },
        cancelEdit() {
            this.$parent.editing = false;
            this.cover = null;
            this.formType = 'create';
            this.repeat = {
                sale: [
                    {
                        isCoverItem: false,
                        propertyId: null,
                        gallery: null,
                        selectedImg: 0,
                        photo: {
                            id: null,
                            url: null
                        }
                    }
                ],
                rent: [
                    {
                        isCoverItem: false,
                        propertyId: null,
                        gallery: null,
                        selectedImg: 0,
                        photo: {
                            id: null,
                            url: null
                        }
                    }
                ]
            };
            this.formData = {
                Name: null,
                Type: '',
                Data: {
                    CoverURL: null,
                    ForSale: [],
                    ForRent: []
                },
                criteria: this.defaultCriteria
            };
        },
        async editTemplate( templateName ) {
            this.$store.dispatch( 'appLoading', true );

            const response = await http.get( '/emailtemplates/' + templateName );

            const data = await response.json();

            if ( response.status === 200 ) {
                let activeCover = data.Data.CoverURL;

                this.formData.Name = data.Name;
                this.formData.Type = data.Type;
                this.cover = data.Data.CoverURL;

                if ( data.hasOwnProperty( 'criteria' ) && data.criteria !== null ) {
                    this.formData.criteria = data.criteria;
                }

                let rent = data.Data.ForRent;
                let sale = data.Data.ForSale;

                this.repeat.sale = [];
                this.repeat.rent = [];

                // it has sale properties - fill up
                if ( typeof sale !== 'undefined' ) {
                    for ( let i = 0; i < sale.length; i++ ) {
                        if ( sale[ i ].dispatchPropertyID === null ) {
                            continue;
                        }

                        let itemSale = {
                            isCoverItem: false,
                            propertyId: sale[ i ].PropertyID,
                            isPublic: null,
                            gallery: null,
                            selectedImg: 0,
                            photo: {
                                id: null,
                                url: sale[ i ].PhotoUrl
                            }
                        };

                        let imgCoverAux = this.getImgUrlCover( sale[ i ].PhotoUrl, 'c640x480' );

                        let res = await this.getPropertyGallery( sale[ i ].PropertyID );

                        itemSale.isPublic = res.isPublic;

                        itemSale.gallery = res.gallery;

                        let saleGallery = res.gallery;

                        for ( let j = 0; j < saleGallery.length; j++ ) {
                            if ( this.getImgUrl( saleGallery[ j ].url, 'c400x300' ) === sale[ i ].PhotoUrl ) {
                                itemSale.selectedImg = saleGallery[ j ].id;
                            }
                            if ( imgCoverAux === activeCover ) {
                                itemSale.isCoverItem = true;
                            }
                        }

                        this.repeat.sale.push( itemSale );
                    }
                }

                // it has rent properties - fill up
                if ( typeof rent !== 'undefined' ) {
                    for ( let i = 0; i < rent.length; i++ ) {
                        if ( rent[ i ].PropertyID === null ) {
                            continue;
                        }

                        let itemRent = {
                            isCoverItem: false,
                            propertyId: rent[ i ].PropertyID,
                            isPublic: null,
                            gallery: null,
                            selectedImg: 0,
                            photo: {
                                id: null,
                                url: rent[ i ].PhotoUrl
                            }
                        };

                        let imgCoverAux = this.getImgUrlCover( rent[ i ].PhotoUrl, 'c640x480' );

                        const res = await this.getPropertyGallery( rent[ i ].PropertyID );

                        itemRent.isPublic = res.isPublic;

                        itemRent.gallery = res.gallery;

                        let rentGallery = res.gallery;

                        for ( let j = 0; j < rentGallery.length; j++ ) {
                            if ( this.getImgUrl( rentGallery[ j ].url, 'c400x300' ) === rent[ i ].PhotoUrl ) {
                                itemRent.selectedImg = rentGallery[ j ].id;
                            }
                            if ( imgCoverAux === this.cover ) {
                                itemRent.isCoverItem = true;
                            }
                        }

                        this.repeat.rent.push( itemRent );
                    }
                }

                this.$parent.editing = true;
                this.formType = 'edit';
            }

            this.$store.dispatch( 'appLoading', false );
        },
        async deleteTemplate( templateName ) {
            this.$store.dispatch( 'appLoading', true );

            let r = confirm( 'Are you sure?' );

            if ( r == true ) {
                const response = await http.delete( `/emailtemplates/${templateName}` );
                if ( response.status === 200 ) {
                    notify( {
                        type: 'success',
                        text: 'Template was deleted correctly',
                        title: 'Template deleted OK'
                    } );
                    this.getTemplates();
                    this.cancelEdit();
                }
            }
            this.$store.dispatch( 'appLoading', false );
        },
        searchTemplates( e ) {
            e.preventDefault();
            this.getTemplates();
        },
        async getTemplates() {
            this.$store.dispatch( 'appLoading', true );

            if ( this.formSearch.Name == null ) {
                delete this.formSearch.Name;
            }

            if ( this.formSearch.Type == null ) {
                delete this.formSearch.Type;
            }

            let params = new URLSearchParams( this.formSearch ).toString();

            const response = await http.get( '/emailtemplates?' + params );

            if ( response.status === 200 ) {
                this.listTemplatesCreated = await response.json();
            }

            this.$store.dispatch( 'appLoading', false );
        },
        async sendForm( e ) {
            e.preventDefault();

            this.formData.Data = {
                CoverURL: null,
                ForSale: [],
                ForRent: []
            };

            this.$store.dispatch( 'appLoading', true );

            let allRent = this.repeat.rent;
            let allSale = this.repeat.sale;

            this.editOK = true;

            if ( this.formData.Type === '' ) {
                notify( {
                    type: 'error',
                    text: 'Please pick a type',
                    title: 'Pick Type'
                } );
                this.editOK = false;
                this.$store.dispatch( 'appLoading', false );
            }

            if ( !this.formData.Name ) {
                notify( {
                    type: 'error',
                    text: 'Please enter a name',
                    title: 'Enter name'
                } );
                this.editOK = false;
                this.$store.dispatch( 'appLoading', false );
                return;
            }

            if ( !/^[a-zA-Z0-9._-]{5,}$/.test( this.formData.Name ) ) {
                notify( {
                    type: 'error',
                    text: 'Please enter a valid name',
                    title: 'Invalid name'
                } );
                this.editOK = false;
                this.$store.dispatch( 'appLoading', false );
                return;
            }

            if ( this.formData.Type === 'featured' || this.formData.Type == 'featured-province' ) {
                if ( allRent[ 0 ].propertyId == null ) {
                    notify( {
                        type: 'error',
                        text: 'Please add some Rent Properties'
                    } );
                    this.$store.dispatch( 'appLoading', false );
                    return;
                }

                allRent.forEach( item => {
                    if ( item.selectedImg === 0 ) {
                        notify( {
                            type: 'error',
                            text: 'One property has no image selected. Please pick one',
                            title: 'Pick Image'
                        } );
                        this.editOK = false;
                        this.$store.dispatch( 'appLoading', false );
                    } else {
                        if ( item.gallery != null ) {
                            this.formData.Data.ForRent.push( {
                                PropertyID: parseInt( item.propertyId ),
                                PhotoUrl: this.getImgUrl( item.gallery[ item.selectedImg - 1 ].url, 'c400x300' )
                            } );
                        }
                    }
                } );
            } else {
                delete this.formData.Data.ForRent;
            }

            allSale.forEach( item => {
                if ( item.selectedImg === 0 ) {
                    notify( {
                        type: 'error',
                        text: 'One property has no image selected. Please pick one',
                        title: 'Pick Image'
                    } );
                    this.editOK = false;
                    this.$store.dispatch( 'appLoading', false );
                } else {
                    if ( item.gallery != null ) {
                        this.formData.Data.ForSale.push( {
                            PropertyID: parseInt( item.propertyId ),
                            PhotoUrl: this.getImgUrl( item.gallery[ item.selectedImg - 1 ].url, 'c400x300' )
                        } );
                    }
                }
            } );

            if ( this.cover == null ) {
                notify( {
                    type: 'error',
                    text: 'Please pick one cover image',
                    title: 'Pick Cover'
                } );
                this.editOK = false;
                this.$store.dispatch( 'appLoading', false );
            }

            this.formData.Data.CoverURL = this.cover;

            if ( !allSale || allSale.length === 0 ) {
                this.formData.criteria.forSale.minSelected = 0;
            }

            // condition from above - only featured email template can have allRent
            if ( this.formData.Type !== 'featured' && this.formData.Type !== 'featured-province' ) {
                this.formData.criteria.forRent.minSelected = 0;
            }

            // this condition will fail for templates that do not have rentals
            // as allRent will have single item (one to be filled up)
            if ( !allRent || allRent.length === 0 ) {
                this.formData.criteria.forRent.minSelected = 0;
            }

            // creating template
            if ( this.formType == 'create' ) {
                const response = await http.post( '/emailtemplates', this.formData );

                if ( response.status === 200 ) {
                    notify( {
                        type: 'success',
                        text: 'Template was added correctly',
                        title: 'Template created OK'
                    } );
                    this.$store.dispatch( 'appLoading', false );
                    this.getTemplates();
                    this.cancelEdit();

                    // reset form
                    this.formData.Name = null;
                    this.formData.Type = '';
                    this.formData.Data.CoverURL = null;
                    this.formData.Data.ForSale = [];
                    this.formData.Data.ForRent = [];
                    this.$parent.adding = false;
                    this.formData.criteria = this.defaultCriteria;
                }

                this.$store.dispatch( 'appLoading', false );
            }

            // editing template
            if ( this.editOK == true && this.formType == 'edit' ) {
                let name = this.formData.Name;

                delete this.formData.Name;

                const response = await http.put( `/emailtemplates/${name}`, this.formData );

                if ( response.status === 200 ) {
                    notify( {
                        type: 'success',
                        text: 'Template was edited correctly',
                        title: 'Template edited OK'
                    } );

                    this.$store.dispatch( 'appLoading', false );
                    this.getTemplates();
                    this.cancelEdit();

                    // reset form
                    this.formData.Name = null;
                    this.formData.Type = '';
                    this.formData.Data.CoverURL = null;
                    this.formData.Data.ForSale = [];
                    this.formData.Data.ForRent = [];
                    this.$parent.adding = false;
                    this.$parent.editing = false;
                    this.formData.criteria = this.defaultCriteria;
                }

                this.$store.dispatch( 'appLoading', false );
            }
        },
        coverItemUrl( item ) {
            if ( typeof item.gallery[ item.selectedImg - 1 ] != 'undefined' ) {
                return this.getImgUrl( item.gallery[ item.selectedImg - 1 ].url, 'c640x480' );
            } else {
                return this.getImgUrl( item.gallery[ item.selectedImg ].url, 'c640x480' );
            }
        },
        thisCoverActive( item ) {
            return this.cover === this.getImgUrl( item.gallery[ item.selectedImg - 1 ].url, 'c640x480' );
        },

        toggleCover( item, event ) {
            let allSale = this.repeat.sale;
            let allRent = this.repeat.rent;

            allSale.forEach( function( item ) {
                item.isCoverItem = false;
            } );

            allRent.forEach( function( item ) {
                item.isCoverItem = false;
            } );

            item.isCoverItem = true;

            let targ = event.target;
            this.cover = targ.value;

            this.thisCoverActive( item );
        },
        onlyNumber( e ) {
            e.target.value = e.target.value.replace( /[^0-9]+/g, '' );
        },
        async sendEmailTest( data ) {
            const params = {
                email: data.email,
                language: data.language,
                currency: data.currency,
                provinces: data.provinces,
                regions: data.regions
            };

            const response = await http.post( this.emailTestModal.url, params );
            if ( response.status === 200 ) {
                notify( {
                    type: 'success',
                    text: 'Please check the email to see the email test sent',
                    title: 'Test sent OK'
                } );

                this.emailTestModal.open = false;
            }
            this.$store.dispatch( 'appLoading', false );
        },
        openTest( template_name, url ) {
            this.emailTestModal.open = true;
            this.emailTestModal.url = url;
        },
        getImgUrlCover( src, size ) {
            var srcarr = src.split( '/' );
            var arrsize = srcarr.length;
            var simg = 'c400x300';

            if ( typeof size !== 'undefined' ) {
                simg = size;
            }

            var srcimg = srcarr[ arrsize - 1 ];

            return 'https://' + srcarr.splice( 2, arrsize - 4 ).join( '/' ) + '/' + simg + '/' + srcimg;
        },
        getImgUrl( src, size ) {
            var srcarr = src.split( '/' );
            var arrsize = srcarr.length;
            var simg = 'c400x300';

            if ( typeof size !== 'undefined' ) {
                simg = size;
            }

            var srcimg = srcarr[ arrsize - 1 ];

            return 'https://' + srcarr.splice( 2, arrsize - 3 ).join( '/' ) + '/' + simg + '/' + srcimg;
        },
        openModalImg( item ) {
            if ( typeof item.gallery[ item.selectedImg - 1 ] === 'undefined' ) {
                return;
            }

            let src = item.gallery[ item.selectedImg - 1 ].url;

            this.imgPreviewModal.open = true;
            this.imgPreviewModal.img = this.getImgUrl( src );
        },
        setPhotoObj( propertyObj, event ) {
            let targ = event.target;
            let selectedOptionItem = targ.selectedOptions[ 0 ];

            let switchCont = targ.parentNode.parentNode.parentNode.children[ 2 ];
            let switchCtn = switchCont.children[ 0 ].children[ 0 ];
            let switchLabel = switchCont.children[ 0 ].children[ 1 ];

            switchCtn.setAttribute( 'id', 'switch' + propertyObj.propertyId );
            switchLabel.setAttribute( 'for', 'switch' + propertyObj.propertyId );

            propertyObj.photo.id = selectedOptionItem.value;
            propertyObj.photo.url = this.getImgUrl( selectedOptionItem.dataset.url );
        },
        orderPhotos( a, b ) {
            if ( a.Number < b.Number ) {
                return -1;
            }

            if ( a.Number > b.Number ) {
                return 1;
            }
            return 0;
        },
        async getPropertyGallery( propertyID ) {
            let propertyObj = {
                gallery: null,
                isPublic: true
            };

            const response = await http.get( `/property/${propertyID}` );

            if ( response.status === 200 ) {
                let data = await response.json();

                if ( data.length === 0 ) {
                    alert( 'empty response returned' );
                    return;
                }

                if ( data.IsPublic === false ) {
                    notify( {
                        type: 'error',
                        text: `Property with ID ${propertyID} is OFFLINE`
                    } );
                    propertyObj.isPublic = false;
                }

                let photos = [];

                for ( let key in data[ 'Photos' ] ) {
                    let imgaux = {
                        id: null,
                        url: null
                    };

                    imgaux.id = data[ 'Photos' ][ key ].Number;
                    imgaux.url = data[ 'Photos' ][ key ].CdnUrl;

                    if ( imgaux.url.length > 0 ) {
                        photos.push( imgaux );
                    }
                }

                propertyObj.gallery = photos.sort( function( a, b ) {
                    return a.id - b.id;
                } );

                if ( photos.length === 0 ) {
                    notify( {
                        type: 'error',
                        text: 'This property has no images. Please pick another'
                    } );
                    propertyObj.gallery = null;
                }

                return propertyObj;
            } else {
                notify( {
                    type: 'error',
                    text: 'There was an error. Please try again and check ID is correct'
                } );
                propertyObj.gallery = null;
            }
        },
        async checkActiveSelect( propertyObj ) {
            let e = event;
            let val = parseInt( e.target.value );

            if ( !Number.isInteger( val ) ) {
                propertyObj.gallery = null;
                return;
            }

            const response = await http.get( `/property/${val}` );
            if ( response.status === 200 ) {
                let data = await response.json();

                if ( data.length === 0 ) {
                    alert( 'empty response returned' );
                    e.target.value = null;
                    propertyObj.gallery = null;
                    return;
                }

                if ( data.IsPublic == false ) {
                    notify( {
                        type: 'error',
                        text: 'This property is not public. Please pick another'
                    } );
                    e.target.value = null;
                    propertyObj.gallery = null;
                    return;
                }

                let photos = [];

                for ( let key in data[ 'Photos' ] ) {
                    let imgaux = {
                        id: null,
                        url: null
                    };

                    imgaux.id = data[ 'Photos' ][ key ].Number;
                    imgaux.url = data[ 'Photos' ][ key ].CdnUrl;

                    if ( imgaux.url.length > 0 ) {
                        photos.push( imgaux );
                    }
                }
                propertyObj.gallery = photos.sort( function( a, b ) {
                    return a.id - b.id;
                } );

                if ( photos.length == 0 ) {
                    notify( {
                        type: 'error',
                        text: 'This property has no images. Please pick another'
                    } );
                    e.target.value = null;
                    propertyObj.gallery = null;
                } else {
                    propertyObj.photo.id = photos[ 0 ].id;
                    propertyObj.photo.url = this.getImgUrl( photos[ 0 ].url );
                    propertyObj.selectedImg = photos[ 0 ].id;
                }
            } else {
                notify( {
                    type: 'error',
                    title: 'Something went wrong',
                    text: 'Please try again'
                } );
                e.target.value = null;
                propertyObj.gallery = null;
            }
        },
        removeRepeatBlock( index, type ) {
            if ( type === 'sale' ) {
                this.repeat.sale.splice( index, 1 );
            } else if ( type === 'rent' ) {
                this.repeat.rent.splice( index, 1 );
            }
        },
        repeatBlock( type ) {
            if ( type === 'sale' ) {
                this.repeat.sale.push( {
                    propertyId: null,
                    isCoverItem: false,
                    gallery: null,
                    selectedImg: 0,
                    photo: {
                        id: null,
                        url: null
                    }
                } );
            } else if ( type === 'rent' ) {
                this.repeat.rent.push( {
                    propertyId: null,
                    isCoverItem: false,
                    gallery: null,
                    selectedImg: 0,
                    photo: {
                        id: null,
                        url: null
                    }
                } );
            }
        }
    },
    components: {
        draggable,
        ImgPreviewModal,
        EmailTestModal
    },
    mounted() {
        this.getTemplates();
        document.title = 'thinkSPAIN - Templates';
    }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/templates/form/index.vue